import { useState } from "react";
import "./App.css";
import MainPage from "./MainPage";
import DemoPage from "./DemoPage";

function App() {
  const [index, setIndex] = useState(-1);

  const onClickMain = () => {
    setIndex(-1);
  };
  const onClickDemo = (newIndex) => () => {
    setIndex(newIndex);
  };

  return (
    <>
      {index === -1 ? (
        <MainPage onClickDemo={onClickDemo} />
      ) : (
        <DemoPage index={index} onClickMain={onClickMain} />
      )}
    </>
  );
}

export default App;
